import { isLibrary, isLocked } from '@alfresco/aca-shared';
import { ShareDataRow } from '@alfresco/adf-content-services';
import { Node } from '@alfresco/js-api';

function isLockedNode(node) {
  return (
    node.isLocked ||
    (node.properties && node.properties['cm:lockType'] === 'READ_ONLY_LOCK')
  );
}

function isWorkingCopy(node) {
  if (node.aspectNames && node.aspectNames.indexOf('cm:workingcopy') !== -1) {
    return true;
  }
  return false;
}

const iconsList = new Map([
  ['HTML', 'format_html.svg'],
  ['Media', 'format_media.svg'],
  ['Image', 'format_jpg.svg'],
  ['Adobe PDF Document', 'format_pdf.svg'],
  ['Plain Text', 'format_txt.svg'],
  ['XML', 'format_xml.svg'],
  ['PowerPoint', 'format_ppt.svg'],
  ['Word', 'format_doc.svg'],
  ['Excel', 'format_xls.svg'],
]);
const lockIcon = 'assets/images/lock.svg';

export const imageResolver = (row: ShareDataRow): string | null => {
  const entry: Node = row.node.entry;

  if (isLockedNode(entry)) {
    return lockIcon;
  }

  if (isWorkingCopy(entry)) {
    return lockIcon;
  }

  if (isLocked(row.node)) {
    return lockIcon;
  }

  if (isLibrary(row.node)) {
    return 'assets/images/baseline-library_books-24px.svg';
  }

  if (
    entry?.content?.mimeTypeName &&
    entry.isFile &&
    entry?.content?.mimeType
  ) {
    if (/video|audio/g.test(entry.content.mimeType)) {
      return `assets/images/${iconsList.get('Media')}`;
    } else if (/image/g.test(entry.content.mimeType)) {
      return `assets/images/${iconsList.get('Image')}`;
    } else if (/Microsoft PowerPoint/g.test(entry.content.mimeTypeName)) {
      return `assets/images/${iconsList.get('PowerPoint')}`;
    } else if (/Microsoft Word/g.test(entry.content.mimeTypeName)) {
      return `assets/images/${iconsList.get('Word')}`;
    } else if (/Microsoft Excel/g.test(entry.content.mimeTypeName)) {
      return `assets/images/${iconsList.get('Excel')}`;
    } else if (iconsList?.has(entry.content.mimeTypeName)) {
      return `assets/images/${iconsList.get(entry.content.mimeTypeName)}`;
    }
  }

  if (entry && entry.isFolder) {
    return 'assets/images/format_folder.svg';
  }
  return null;
};
